import { FunctionComponent } from 'react';

export const Divider: FunctionComponent = () => {
  return <hr className="border-gray-300/50 dark:border-neutral-700" />;
};
